import { Check, Pencil } from 'lucide-react';

interface Props {
  editing: boolean;
  saving: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
}

/** Edit, or Cancel + Save while editing, for the workshop details card. */
export function WorkshopEditActions({ editing, saving, onEdit, onCancel, onSave }: Props) {
  if (!editing) {
    return (
      <button type="button" className="nb-btn nb-btn-ghost" onClick={onEdit}>
        <Pencil size={13} />
        Edit
      </button>
    );
  }
  return (
    <>
      <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button type="button" className="nb-btn nb-btn-primary" onClick={onSave} disabled={saving}>
        <Check size={13} />
        {saving ? 'Saving…' : 'Save'}
      </button>
    </>
  );
}
